import { combineReducers } from "redux";
import WatchListGroups from "./WatchListGroups";
import particulatWatchlist from "./particularWatchList";
import getGloblePin from "./getGloblePin";
import searchWatchlist from "./searchWatchList";
export default combineReducers({
    WatchListGroups,
    particulatWatchlist,
    getGloblePin,
    searchWatchlist
});
